module.exports = __webpack_public_path__ + "static/media/radio-waves-router.d7f2b14b.svg";